





















































































/** @format */

import { Component, Vue, Mixins, Watch } from 'vue-property-decorator';
// @ts-ignore hack
import TableMixin from '@root/common/mixins/table';
// @ts-ignore hack
import TableWidthMixin from '@root/common/mixins/table-width';
import ParkingLotSearch from '../../../components/parking-lot-search/index.vue';
import moment from 'moment';
import * as api from '../../../api/statistic-analysis';
// @ts-ignore hack
import EchartOption from '@root/common/const/e-chart-options';
import _ from 'lodash';

@Component({
  name: 'TemporaryIncome',
  components: {
    ParkingLotSearch
  }
})
export default class TemporaryIncome extends Mixins(TableMixin, TableWidthMixin) {
  // 统计颗粒度
  dimensions: string = '0';
  // 快捷时间范围按钮
  timeQuickSelect: any = {
    '0': [{ value: 1, text: '近7天' }, { value: 2, text: '近1月' }, { value: -1, text: '自定义' }],
    '1': [{ value: 3, text: '近半年' }, { value: 4, text: '本年' }, { value: -1, text: '自定义' }]
  };

  timeQuickButtons: any[] = this.timeQuickSelect[this.dimensions];

  // 选择的时间范围
  timeRangeType: number = 1;

  // 自定义时间
  customTime: any[] = [];
  customTimeFormat: string = 'YYYY-MM-DD';
  customTimeMode: string[] = ['date', 'date'];

  // @Watch('dimensions')
  onDimensionsChange() {
    // 变换快捷按钮
    this.timeQuickButtons = this.timeQuickSelect[this.dimensions];
    this.timeRangeType = this.timeQuickButtons[0].value;
    if (this.dimensions == '0') {
      this.customTimeMode = ['date', 'date'];
      this.customTimeFormat = 'YYYY-MM-DD';
    } else if (this.dimensions == '1') {
      this.customTimeMode = ['month', 'month'];
      this.customTimeFormat = 'YYYY-MM';
    }
    this.onTimeRangeTypeChange();
  }

  onCustomTimeChange(date: any, dateString: any) {
    if (date.length === 0) {
      // 重新设置快捷按钮
      this.onDimensionsChange();
    } else {
      const [startTime, endTime] = date;
      // 清空快捷设置
      if (this.dimensions == '0') {
        this.filterParam.startTime = startTime.startOf('day').format('YYYY-MM-DD');
        this.filterParam.endTime = endTime.endOf('day').format('YYYY-MM-DD');
      } else if (this.dimensions == '1') {
        this.filterParam.startTime = startTime.startOf('month').format('YYYY-MM');
        this.filterParam.endTime = endTime.endOf('month').format('YYYY-MM');
      }
    }
  }

  onCustomTimeChange2(date: any, dateString: any) {
    // 自定义，清空快捷按钮
    const [startTime, endTime] = date;
    this.customTime = [startTime, endTime];
    if (this.dimensions == '0') {
      this.filterParam.startTime = startTime.startOf('day').format('YYYY-MM-DD');
      this.filterParam.endTime = endTime.endOf('day').format('YYYY-MM-DD');
    } else if (this.dimensions == '1') {
      this.filterParam.startTime = startTime.startOf('month').format('YYYY-MM');
      this.filterParam.endTime = endTime.endOf('month').format('YYYY-MM');
    }
  }

  // @Watch('timeRangeType')
  onTimeRangeTypeChange() {
    this.current = 1;
    // 快捷按钮，计算时间范围
    if (this.timeRangeType !== -1) {
      this.customTime = [];
      let startTime, endTime;
      switch (this.timeRangeType) {
        case 1:
          // 近7天
          startTime = moment()
            .startOf('d')
            .subtract(7, 'd');
          endTime = moment()
            .endOf('d')
            .subtract(1, 'd');
          break;
        case 2:
          // 近1月
          startTime = moment()
            .subtract(1, 'd')
            .startOf('d')
            .subtract(1, 'month');
          endTime = moment()
            .subtract(1, 'd')
            .endOf('d');
          break;
        case 3:
          // 近半年
          startTime = moment()
            .startOf('month')
            .subtract(5, 'month');
          endTime = moment().endOf('month');
          break;
        case 4:
          // 本年
          startTime = moment().startOf('year');
          endTime = moment().endOf('year');
          break;
        default:
          startTime = moment().startOf('d');
          endTime = moment().endOf('d');
      }
      if (this.dimensions == '0') {
        this.filterParam.startTime = startTime.startOf('day').format('YYYY-MM-DD');
        this.filterParam.endTime = endTime.endOf('day').format('YYYY-MM-DD');
      } else if (this.dimensions == '1') {
        this.filterParam.startTime = startTime.startOf('month').format('YYYY-MM');
        this.filterParam.endTime = endTime.endOf('month').format('YYYY-MM');
      }
      this.fetchTableData();
    }
  }

  // 选择的车场
  selectParkIds: Array<string> = [];

  @Watch('selectParkIds')
  onSelectParkIdChange() {
    this.current = 1;
    this.fetchTableData();
  }

  public filterParam: any = {
    startTime: '',
    endTime: ''
  };
  current: number = 1;
  pageSize: number = 10;
  total: number = 0;
  tableData: any[] = [];
  tableLoading: boolean = false;
  chartData: any[] = [];
  options: EchartOption = new EchartOption();

  clear({ defaultParkIdList }) {
    this.dimensions = '0';
    this.timeRangeType = 1;
    this.selectParkIds = defaultParkIdList;
    this.customTime = [];
    this.onDimensionsChange();
  }

  // 初始化加载，确保机构树有值
  init() {
    this.onTimeRangeTypeChange();
    this.fetchTableData();
  }

  private created() {
    this.init();
  }

  /**
   * 点击搜索按钮
   */
  private search() {
    this.current = 1;
    this.fetchTableData();
  }
  private showSizeChangerChange(current: any, pageSize: any) {
    this.current = current;
    this.pageSize = pageSize;
    this.fetchTableData();
  }
  public async fetchTableData() {
    try {
      if (this.tableLoading) return;
      this.tableLoading = true;
      const param: any = {
        chkDayStart: this.filterParam.startTime,
        chkDayEnd: this.filterParam.endTime,
        type: this.dimensions,
        currPage: this.current,
        pageSize: this.pageSize,
        parkIds: this.selectParkIds.join(',')
      };

      const res = await api.reportTemporaryAnalysisList(param);

      const data = res.data;
      if (data) {
        const { pageSize = 0, currPage = 0, totalPage, totalNum = 0, datas = [], total } = data;
        this.total = Number(totalNum);
        this.tableData = datas;
        if (total) {
          this.tableData.push({
            isTotal: true,
            parkName: '',
            totalAmount: total.totalAmount,
            discountAmount: total.discountAmount,
            paidAmount: total.paidAmount,
            unpaidAmount: total.unpaidAmount,
            cancelAmount: total.cancelAmount,
            unusualRate: total.unusualRate
          });
        }
      }
      await this.fetchChartData(param);
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }

  private async fetchChartData(param: any) {
    // 图表查询不分页
    param.currPage = 0;
    param.pageSize = 0;
    try {
      const res = await api.reportTemporaryAnalysisList(param);
      const data = res.data;
      if (data) {
        const { datas = [] } = data;
        this.chartData = datas;
      }
    } catch (e) {
      console.log(e);
    } finally {
      this.refreshChart();
    }
  }

  private async download() {
    try {
      const param: any = {
        chkDayStart: this.filterParam.startTime,
        chkDayEnd: this.filterParam.endTime,
        type: this.dimensions,
        currPage: this.current,
        pageSize: this.pageSize,
        parkIds: this.selectParkIds.join(',')
      };
      await api.reportTemporaryAnalysisExport(param);
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
      console.log('exportLocalcashExport', '导出失败');
    }
  }

  private disabledDate(current: any) {
    return current && current >= moment().endOf('day');
  }

  getPopupContainer() {
    return this.$refs.panel['$el'];
  }

  get tableColums() {
    return [
      {
        title: '序号',
        width: 80,
        customRender: (text: any, record: any, index: number) => {
          if (record.isTotal === true) {
            return '合计';
          }
          return `${(this.current - 1) * this.pageSize + index + 1}`;
        }
      },

      {
        title: '车场名称',
        dataIndex: 'parkName',
        width: 170,
        scopedSlots: { customRender: 'parkName' }
      },
      {
        title: '时间',
        dataIndex: 'reportDay'
      },
      {
        title: '应收金额',
        dataIndex: 'totalAmount',
        customRender: this.numberRender
      },
      {
        title: '优惠金额',
        dataIndex: 'discountAmount',
        customRender: this.numberRender
      },
      {
        title: '实收金额',
        dataIndex: 'paidAmount',
        customRender: this.numberRender
      },
      {
        title: '减免金额',
        dataIndex: 'cancelAmount',
        customRender: this.numberRender
      },
      {
        title: '应收未收',
        dataIndex: 'unpaidAmount',
        customRender: this.numberRender
      },
      {
        title: '异常金额占比',
        dataIndex: 'unusualRate',
        customRender: v => {
          if (v === '') {
            return '--';
          } else {
            return this.numberRender(v, 2) + '%';
          }
        }
      }
    ];
  }

  numberRender(value: any, num?: any) {
    if (isNaN(value)) {
      return value;
    } else {
      const num = parseFloat(value).toFixed(2);
      return num.replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
    }
  }

  refreshChart() {
    let x = [];
    const y0 = [];
    const y1 = [];
    // 整理数据
    if (this.chartData.length) {
      x = _.union(this.chartData.map(i => i.reportDay).sort());
      for (const date of x) {
        let a0 = 0,
          a1 = 0;
        for (const data of this.chartData) {
          if (data.reportDay === date) {
            // a0 += parseFloat(data.totalAmount)
            a1 += parseFloat(data.paidAmount);
          }
        }
        // y0.push(a0.toFixed(2))
        y1.push(a1.toFixed(2));
      }
    }
    const options: EchartOption = new EchartOption();
    options.setColor(['#1890ff', '#24ccb8']);
    options.setLegend({
      show: false
    });
    options.setGrid({
      top: '8%',
      left: '5%',
      right: '5%',
      bottom: '5%',
      containLabel: true
    });
    options.setXAxis(
      {
        type: 'category',
        boundaryGap: true,
        axisLabel: {
          color: '#000'
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        },
        data: x
      },
      true
    );
    options.setYAxis(
      [
        {
          type: 'value',
          axisLabel: {
            show: true,
            color: '#000'
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#ccc',
              type: 'dashed'
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          }
        }
      ],
      true
    );
    options.setTitle({
      show: false
    });
    options.setSeries([
      // {
      //   name: '应收金额',
      //   type: 'line',
      //   data: y0,
      // },
      {
        name: '实收金额',
        type: 'line',
        data: y1
      }
    ]);
    options.setTooltip({
      show: true,
      trigger: 'axis',
      axisPointer: {
        type: 'line'
      }
    });
    this.options = options;
  }
}
